const {
    autocompletes,
    translations,
    courseTypes,
    categories,
    languages,
    dayTimes,
    weekDays,
    settings,
    filters,
    courses,
    schools,
    levels,
    events,
    blog,
    skills,
    perks
} = require('../repository')

module.exports = () => {
    return {
        autocompletes: new autocompletes(),
        translations: new translations(),
        courseTypes: new courseTypes(),
        categories: new categories(),
        languages: new languages(),
        dayTimes: new dayTimes(),
        weekDays: new weekDays(),
        settings: new settings(),
        filters: new filters(),
        courses: new courses(),
        schools: new schools(),
        levels: new levels(),
        events: new events(),
        blog: new blog(),
        skills: new skills(),
        perks: new perks()
    }
}
